import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  content: {
    width: '100%',
  },
});

export default useStyles;
